import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState } from "react";
import { theme } from "app/App";

export default function BasicAccordion({
    defaultExpanded = true,
    title,
    titleActions,
    fullWidth = false,
    children,
    sx,
    ...props
}) {
    const [expanded, setExpanded] = useState(defaultExpanded);

    return (
        <Accordion
            expanded={expanded}
            onChange={(event, value) => setExpanded(value)}
            sx={{ flexBasis: fullWidth ? "100%" : null, ...sx }}
            {...props}
        >
            <AccordionSummary
                // TODO: mover cores para o tema.
                expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
                sx={{
                    display: "flex",
                    backgroundColor: theme.palette.grey[800],
                }}
            >
                <Typography sx={{ display: "flex", alignItems: "center", flex: 1, fontSize: "0.9em", color: "white" }}>
                    {title}
                </Typography>

                {titleActions}
            </AccordionSummary>

            <AccordionDetails sx={{ p: 2 }}>{children}</AccordionDetails>
        </Accordion>
    );
}
